import BaseComponentModel from './base-component-model';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';
import { ApplicationSettings } from '../../models/settings';
import { extractCloudinaryImage } from '../../utils/mapping-helpers/cloudinary.helper';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';
import ITestimonialCard from '../../models/testimonial/ITestimonialCard';

export default class TestimonialCardSetComponentModel extends BaseComponentModel {
  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'TestimonialCardSet';
  cards: ITestimonialCard[] = [];
  appSettings: ApplicationSettings;
  id?: string;
  title?: string;

  constructor(data: any, appSettings: ApplicationSettings) {
    super('testimonialCardSet', appSettings);
    this.appSettings = appSettings;
    this.id = data.id;
    this.title = data.title;

    if (!this.isEntityValid(data)) return;
    this.cards = this.filterAndTransformCards(data.cards as Entry<any>[]);
  }

  private isEntityValid(data: any): boolean {
    const validation = this.shouldReturnEntity(data);
    if (validation.shouldReturn) return true;

    this.exclusionReasons.push(...validation.shouldNotReturnReasons);
    this.isValid = false;
    return false;
  }

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      ['cards'],
      ['cards'],
    );
  }

  protected shouldReturnChildEntities(entry: Entry<any>): IShouldReturnEntity {
    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      ['fields'],
      ['fields'],
    );
  }

  private filterAndTransformCards(cards: Entry<any>[]): ITestimonialCard[] {
    const includedCards: ITestimonialCard[] = [];
    for (const card of cards) {
      const validation = this.shouldReturnChildEntities(card);
      if (validation.shouldReturn) {
        includedCards.push(this.transformCard(card));
      } else {
        this.exclusionReasons.push(...validation.shouldNotReturnReasons);
      }
    }
    return includedCards;
  }

  private transformCard(card?: Entry<any>): ITestimonialCard {
    const cardFields = card?.fields;
    return {
      id: card?.sys.id,
      cardTitle: this.title,
      imageTransform: cardFields?.imageTransform,
      image: extractCloudinaryImage(
        cardFields?.image?.fields?.image,
        cardFields?.image?.fields?.altText,
      ),
      name: cardFields?.name,
      studentCountry: cardFields?.studentCountry,
      quote: cardFields?.quote,
      jobTitleAndCompany: cardFields?.jobTitleAndCompany,
      pathwayCourse: cardFields?.pathwayCourse,
      universityDegree: cardFields?.universityDegree,
    };
  }
}
